import { render } from "./ApiKeyPlans.vue?vue&type=template&id=a9a1b6bc&scoped=true"
import script from "./ApiKeyPlans.vue?vue&type=script&lang=js"
export * from "./ApiKeyPlans.vue?vue&type=script&lang=js"

import "./ApiKeyPlans.vue?vue&type=style&index=0&id=a9a1b6bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9a1b6bc"]])

export default __exports__